import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function GraficoAsistencia({ asistenciaAnual = [], id_usuario, tipo = 'diaria' }) {
  const contarAsistencias = (asistencias_anual, targetId) => {
    let presente = 0;
    let ausente = 0;
    let tarde = 0;
    let retiro = 0;

    if (Array.isArray(asistencias_anual)) {
      asistencias_anual.forEach(a => {
        if (String(a.id_usuario) === String(targetId)) {
          if (a.asistencia === "Presente") presente++;
          else if (a.asistencia === "Ausente") ausente++;
          else if (a.asistencia === "Tarde") tarde++;
          else if (a.asistencia === "Retiro") retiro++;
        }
      });
    }

    return { presente, ausente, tarde, retiro };
  };

  const { presente, ausente, tarde, retiro } = contarAsistencias(asistenciaAnual, id_usuario);
  const total = presente + ausente + tarde + retiro;

  // Colores: Tonalidad clara para la materia, tonalidad oscura para la diaria
  const colores = tipo === 'materia' 
    ? ['#75b798', '#f87171', '#fde047', '#ffb74d'] // Verde claro, Rojo claro, Amarillo claro, Naranja claro
    : ['#198754', '#dc3545', '#d97706', '#fd7e14']; // Verde oscuro, Rojo oscuro, Naranja oscuro, Naranja vivo

  const data = {
    labels: ['Presente', 'Ausente', 'Tarde', 'Retiro'],
    datasets: [
      {
        data: total > 0 ? [presente, ausente, tarde, retiro] : [0, 0, 0, 0, 1],
        backgroundColor: total > 0 ? colores : ['#e0e0e0', '#e0e0e0', '#e0e0e0', '#e0e0e0', '#e0e0e0'],
        borderColor: ['#ffffff'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: total > 0,
        callbacks: {
          label: function(context) {
            if (total === 0) return 'Sin datos cargados';
            return `${context.label}: ${context.raw}`;
          }
        }
      }
    },
    cutout: '30%',
    responsive: true,
    maintainAspectRatio: false
  };

  return (
    <div style={{ width: '45px', height: '45px', margin: '0 auto' }}>
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default GraficoAsistencia;
